import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { DesactiverUtilisateursModel } from 'src/models/pilotage/desactiverUtilisateursModel';
import { ResultDesactiverUtilisateursModel } from 'src/models/pilotage/resultDesactiverUtilisateursModel';
import { MatSnackBar } from '@angular/material/snack-bar';
import { tap } from 'rxjs';
import { ResultDesactiverDialogComponent } from './result-desactiver-dialog/result-desactiver-dialog.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-confirmation-desactiver-dialog',
    templateUrl: './confirmation-desactiver-dialog.component.html',
    styleUrls: ['./confirmation-desactiver-dialog.component.scss'],
    imports: [
        MatDialogModule,
        TranslateModule
    ]
})
export class ConfirmationDesactiverDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDesactiverDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { userIds: number[] },
    private utilisateurService: UtilisateurService,
    private dialog: MatDialog
  ) { }

  onConfirm(): void {
    const desactiverModel: DesactiverUtilisateursModel = {
      utilisateursIds: this.data.userIds,
      entiteIdAccessibles: this.utilisateurService.contexteUtilisateur.entitesAccessibles.map(e => e.entiteId)
    };

    this.utilisateurService.desactiverUtilisateurs(desactiverModel).pipe(
      tap(
        (res: ResultDesactiverUtilisateursModel) => {
          this.dialogRef.close(true);
          this.dialog.open(ResultDesactiverDialogComponent, {
            data: res,
            width: '400px'
          });
        },
      )
    ).subscribe();
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
